import ar from "./config/ar"
import en from "./config/en"
import es from "./config/es"
import fa from "./config/fa"
import fr from "./config/fr"
import id from "./config/id"
import pt from "./config/pt"
import ru from "./config/ru"
import tr from "./config/tr"
import uk from "./config/uk"
import zh from "./config/zh"
import hi from "./config/hi"
import ko from "./config/ko"
import ja from "./config/ja"
import ur from "./config/ur"
import uz from "./config/uz"
import vi from "./config/vi"
import de from "./config/de"
import th from "./config/th"
import bn from "./config/bn"
import pl from "./config/pl"
import fil from "./config/fil"
import {createI18n} from "vue-i18n"
import {getLocalStorage} from "../utils/common"


let messages =  {
    ar:{
        ...ar
    },
    en:{
        ...en
    },
    es:{
        ...es
    },
    fa:{
        ...fa
    },
    fr:{
        ...fr
    },
    id:{
        ...id
    },
    pt:{
        ...pt
    },
    ru:{
        ...ru
    },
    tr:{
        ...tr
    },
    uk:{
        ...uk
    },
    zh:{
        ...zh
    },
    hi:{
        ...hi
    },
    ko:{
        ...ko
    },
    ja:{
        ...ja
    },
    ur:{
        ...ur
    },
    uz:{
        ...uz
    },
    vi:{
        ...vi
    },
    de:{
        ...de
    },
    th:{
        ...th
    },
    bn:{
        ...bn
    },
    pl:{
        ...pl
    },
    fil:{
        ...fil
    },
}

// 通过选项创建 VueI18n 实例
const i18n = createI18n({
    locale: getLocalStorage("nowLanguage") || 'en', // 设置地区(默认是英文)
    globalInjection:true,
    legacy:false,
    messages, // 设置语言包
})


export {i18n};